import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/phone-outgoing-success.svg'
import _imports_1 from '@/assets/chat/phone-incoming-success.svg'
import _imports_2 from '@/assets/chat/phone-outgoing-error.svg'
import _imports_3 from '@/assets/chat/phone-incoming-error.svg'
import _imports_4 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-a020a67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CallLogs" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_4 = { class: "headerIcon" }
const _hoisted_5 = { class: "headerIcon" }
const _hoisted_6 = { class: "headerIcon" }
const _hoisted_7 = { class: "headerIcon" }
const _hoisted_8 = {
  key: 1,
  class: "content"
}
const _hoisted_9 = ["infinite-scroll-disabled"]
const _hoisted_10 = { class: "statusContent callItem" }
const _hoisted_11 = {
  key: 0,
  class: "imgBox_green"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_14 = {
  key: 1,
  class: "imgBox_red"
}
const _hoisted_15 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_16 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_17 = { class: "statusText" }
const _hoisted_18 = { class: "callItem" }
const _hoisted_19 = { class: "callItem" }
const _hoisted_20 = { class: "callItem" }
const _hoisted_21 = { class: "callItem" }
const _hoisted_22 = ["element-loading-text"]
const _hoisted_23 = {
  key: 0,
  class: "noMore"
}
const _hoisted_24 = {
  key: 2,
  class: "empty"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_26 = { class: "empty-text" }
const _hoisted_27 = {
  key: 2,
  class: "content"
}
const _hoisted_28 = ["infinite-scroll-disabled"]
const _hoisted_29 = { class: "statusContent callItem" }
const _hoisted_30 = {
  key: 0,
  class: "imgBox_green"
}
const _hoisted_31 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_32 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_33 = {
  key: 1,
  class: "imgBox_red"
}
const _hoisted_34 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_35 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_36 = { class: "statusText" }
const _hoisted_37 = { class: "callItem mobilePhone" }
const _hoisted_38 = { class: "callItem" }
const _hoisted_39 = { class: "callItem mobileDuration" }
const _hoisted_40 = { class: "callItem" }
const _hoisted_41 = ["element-loading-text"]
const _hoisted_42 = {
  key: 0,
  class: "noMore"
}
const _hoisted_43 = {
  key: 2,
  class: "empty"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_45 = { class: "empty-text" }

import { ref, computed, onMounted, watch, onUnmounted } from "vue";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getCallLogs } from "@/api/devices";
import { dateFormat, formatSecondsToTime, dateFormatAm } from "@/utils/format";
import { ElMessage } from "element-plus";
import loading from "@/components/chat/loading.vue";
import { gaEvent } from "@/utils/format";
import Tooltip from "@/components/common/tooltip.vue";
import { jsonData } from '@/mock/callLogs.js'




export default /*#__PURE__*/_defineComponent({
  __name: 'callLogs',
  emits: ['updateHeaderDate'],
  setup(__props, { emit: __emit }) {

const Emits = __emit
const store = useStore();
const { t } = useI18n();
const tableData = ref<any[]>([])
const id = computed(() => {
  return store.state.currentDeviceId;
});

const currentLang = computed(() => {
  return store.state.currentLang;
});

const isVibe = computed(() => !store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);

// 最后更新时间
let lastUpdateTime = ref(0)
let headerDateArray = ref([])

const showUpdateTime = ref(false)
const globalLoading = ref(false)

// 定义网络请求的起始时间
let startTime = ref('')
let endTime = ref('')
onMounted(async () => {
  console.log("isVibe.value:", isVibe.value, jsonData);

  if (isVibe.value) {
    tableData.value = []
    globalLoading.value = true
    callLogPageNum.value = 1
    cumulativePhoneList = []
    noMorePhone.value = false
    await getCallLogsList()
    gaEvent("Call_PV", {
      event_category: "Call_Logs",
      event_label: tableData.value.length > 0 ? "Data" : "NoData",
    });
  }
  else {
    setNewInterval()
  }
})
onUnmounted(() => {
  clearInterval(closeFiveM);
})

// 五分钟定时更新
let closeFiveM: any
watch(id, async () => {
  tableData.value = []
  globalLoading.value = true
  callLogPageNum.value = 1
  cumulativePhoneList = []
  noMorePhone.value = false
  await getCallLogsList()
  gaEvent("Call_PV", {
    event_category: "Call_Logs",
    event_label: tableData.value.length > 0 ? "Data" : "NoData",
  });
  if (!isVibe.value) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
})

const isCloseLoading = ref(true)
const getCallLogsList = async (isFromScroll: boolean = false, isFromSync: Boolean = false) => {
  // console.log('device_id', callLoading.value,noMorePhone.value);
  let onePagePhoneList: any[] = [];
  let params = {}
  if (!isVibe.value) {
    params = {
      device_id: id.value,
      app: 'native',
      page: callLogPageNum.value,
      start: startTime.value,
      end: endTime.value,
      sort_rule: order.value
    }
  } else {
    tableData.value = jsonData.data.calls
    lastUpdateTime.value = jsonData.data.update_time
    showUpdateTime.value = true
    return
  }
  try {
    const callLogsSourceRef = computed(() => store.state.callLogsSource);
    // 取消掉上一次请求
    callLogsSourceRef.value &&
      callLogsSourceRef.value.cancel("请勿频繁请求通讯录列表接口");
    const res = await getCallLogs(params);
    if (res.data.code == 200 && res.data.message == 'OK') {
      onePagePhoneList = res.data.data.calls;
      if (!isFromSync) {
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      } else {
        gaEvent("Call_Sync", {
          event_category: "Call_Logs",
          event_label: "Success",
        });
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }

      if (res.data.data.total === 0) {
        tableData.value = []
        globalLoading.value = false
        return [];
      }
      cumulativePhoneList = cumulativePhoneList.concat(onePagePhoneList);
      tableData.value = cumulativePhoneList.map((item: any) => {
        return {
          'contact_name': item.contact_name,
          'duration': item.duration ? formatSecondsToTime(item.duration) : '--',
          'phone_number': item.phone_number,
          'status': item.status,
          'date': item.date,
        }
      })

      globalLoading.value = false

      setTimeout(() => {
        isCloseLoading.value = false
      }, 1000)
      console.log("tableData:", tableData);

      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }
  } catch (err) {
    if (isFromSync) {
      gaEvent("Call_Sync", {
        event_category: "Call_Logs",
        event_label: "Fail",
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }
    globalLoading.value = false
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    }, 1000)
  }
}


let order = ref(0)
watch(order, () => {
  console.log('order', order.value);
  // 监听排列顺序的改变，页码要重新变为1
  callLogPageNum.value = 1
  tableData.value = [];
  cumulativePhoneList = [];
  globalLoading.value = true
  // 防止触底过，切换排序不触发再次触底
  noMorePhone.value = false
  getCallLogsList();
  if (!isVibe.value) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
})
const changeOrder = () => {
  switch (order.value) {
    case 0:
      order.value = 1;
      break;
    case 1:
      order.value = 2;
      break;
    case 2:
      order.value = 3;
      break;
    case 3:
      order.value = 0;
      break;
  }
}

const callLoading = ref(false);
let cumulativePhoneList: any[] = [];
let callLogPageNum = ref(1); // 页码
let noMorePhone = ref(false); // 是否展示没有更多数据文案
const disabledCallScroll = computed(
  () => callLoading.value || noMorePhone.value
);
const loadMoreCallLogList = async () => {

  console.log('chudi');
  callLogPageNum.value = callLogPageNum.value + 1;
  callLoading.value = true;
  if (isVibe.value) {
    callLoading.value = false;
    return
  }
  setTimeout(async () => {
    const res: any = await getCallLogsList(true, false);
    callLoading.value = false;
    console.log('res', res);
    if (tableData.value.length >= res.total) {
      // 如果当前列表总长度不是 pageSize的倍数，则显示没有更多数据文案
      noMorePhone.value = true;
    }
  }, 100);
}
const isFirst = ref(true)
const updateHeaderDate = async (value: any) => {
  startTime.value = value[0]
  endTime.value = value[1]
  console.log('接收到的时间：', startTime.value, endTime.value);
  tableData.value = []
  globalLoading.value = true
  noMorePhone.value = false
  callLogPageNum.value = 1
  cumulativePhoneList = []
  await getCallLogsList()
  clearInterval(closeFiveM);
  setNewInterval()
  if (isFirst.value) {
    gaEvent("Call_PV", {
      event_category: "Call_Logs",
      event_label: tableData.value.length > 0 ? "Data" : "NoData",
    });
    isFirst.value = false
  }
};

const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  tableData.value = []
  globalLoading.value = true
  callLogPageNum.value = 1
  cumulativePhoneList = []
  noMorePhone.value = false
  await getCallLogsList(false, true)
  // 清空上一个定时器
  clearInterval(closeFiveM);
  setNewInterval()
}

// 设置新的定时器
const setNewInterval = () => {
  clearInterval(closeFiveM);
  closeFiveM = setInterval(() => {
    tableData.value = []
    callLogPageNum.value = 1
    cumulativePhoneList = []
    noMorePhone.value = false
    getCallLogsList()
  }, 1000 * 60 * 5);
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Call history'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
    _createElementVNode("div", {
      class: _normalizeClass(["label", isShowMore750.value ? '' : 'mobileLabel'])
    }, [
      (isShowMore750.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "status headerIcon",
              onClick: changeOrder
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("famikeep200.Status")), 1),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("famikeep200.Number")), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("famikeep200.Name")), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("famikeep200.Duration")), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("famikeep200.Date")), 1)
          ]))
        : _createCommentVNode("", true),
      (isShowMore750.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (tableData.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  "infinite-scroll-immediate": false,
                  "infinite-scroll-disabled": disabledCallScroll.value,
                  "infinite-scroll-distance": "1"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["calllogsItem", tableData.value.length > 10 ? 'changePadding' : '']),
                      key: item.contactName
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (item.status.toLowerCase().trim() == 'outgoing' ||
                item.status.toLowerCase().trim() == 'incoming'
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (item.status.toLowerCase().trim() == 'outgoing')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                                : _createCommentVNode("", true),
                              (item.status.toLowerCase().trim() == 'incoming')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                : _createCommentVNode("", true)
                            ]))
                          : (item.status.toLowerCase().trim() == 'no answered' ||
                item.status.toLowerCase().trim() == 'missed'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (item.status.toLowerCase().trim() == 'no answered')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                  : _createCommentVNode("", true),
                                (item.status.toLowerCase().trim() == 'missed')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(`famikeep200.${item.status}`)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.phone_number ? item.phone_number : '--'), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(Tooltip, {
                          content: item.contact_name ? item.contact_name : '--'
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.duration), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.date ? (isVibe.value ?
                _unref(dateFormatAm)(item.date, currentLang.value ==
                  "pt" ? "DD-MM-YYYY HH:mm"
                  : "YYYY-MM-DD HH:mm") : _unref(dateFormat)(item.date, currentLang.value == "pt" ? "DD-MM-YYYY HH:mm" :
                    "YYYY-MM-DD HH: mm")) : '--'), 1)
                    ], 2))
                  }), 128)),
                  _withDirectives(_createElementVNode("div", {
                    "element-loading-text": _ctx.$t('chat.loadingText'),
                    style: _normalizeStyle({ 'margin-top': callLoading.value ? '40px' : '10px' })
                  }, null, 12, _hoisted_22), [
                    [_directive_loading, callLoading.value]
                  ]),
                  (_unref(noMorePhone))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9)), [
                  [_directive_infinite_scroll, loadMoreCallLogList]
                ])
              : (globalLoading.value)
                ? (_openBlock(), _createBlock(loading, {
                    key: 1,
                    class: "loading"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("chat.noCallText")), 1)
                  ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (tableData.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: {"height":"100%"},
                  "infinite-scroll-immediate": false,
                  "infinite-scroll-disabled": disabledCallScroll.value,
                  "infinite-scroll-distance": "1"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mobilecalllogsItem",
                      key: item.contactName
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        (item.status.toLowerCase().trim() == 'outgoing' ||
                item.status.toLowerCase().trim() == 'incoming'
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (item.status.toLowerCase().trim() == 'outgoing')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                : _createCommentVNode("", true),
                              (item.status.toLowerCase().trim() == 'incoming')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                                : _createCommentVNode("", true)
                            ]))
                          : (item.status.toLowerCase().trim() == 'no answered' ||
                item.status.toLowerCase().trim() == 'missed'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (item.status.toLowerCase().trim() == 'no answered')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                                  : _createCommentVNode("", true),
                                (item.status.toLowerCase().trim() == 'missed')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t(`famikeep200.${item.status}`)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(item.phone_number ? item.phone_number : '--'), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(Tooltip, {
                          content: item.contact_name ? item.contact_name : '--'
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(item.duration), 1),
                      _createElementVNode("div", _hoisted_40, _toDisplayString(item.date ? (isVibe.value ?
                _unref(dateFormatAm)(item.date, currentLang.value ==
                  "pt" ? "DD-MM-YYYY HH:mm"
                  : "YYYY-MM-DD HH:mm") : _unref(dateFormat)(item.date, currentLang.value == "pt" ? "DD-MM-YYYY HH:mm" :
                    "YYYY-MM-DD HH: mm")) : '--'), 1)
                    ]))
                  }), 128)),
                  _withDirectives(_createElementVNode("div", {
                    "element-loading-text": _ctx.$t('chat.loadingText'),
                    style: _normalizeStyle({ 'margin-top': callLoading.value ? '40px' : '10px' })
                  }, null, 12, _hoisted_41), [
                    [_directive_loading, callLoading.value]
                  ]),
                  (_unref(noMorePhone))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_28)), [
                  [_directive_infinite_scroll, loadMoreCallLogList]
                ])
              : (globalLoading.value)
                ? (_openBlock(), _createBlock(loading, {
                    key: 1,
                    class: "loading"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("chat.noCallText")), 1)
                  ]))
          ]))
    ], 2)
  ]))
}
}

})